import ApplicationsContext from "app/contexts/app/ApplicationsContext";
import { useContext } from "react";

const useApplications = () => useContext(ApplicationsContext);

export default useApplications;
